import React, { useState } from 'react'
import ProjectManagement from '../components/ProjectManagement/ProjectManagement'

const PageProjectManagement = () => {
  return (
    <>
      <ProjectManagement></ProjectManagement>
    </>
  )
}

export default PageProjectManagement
